import React, { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import { useDispatch, useSelector } from "react-redux";
import { updateFolder } from "../../../../redux/docs";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
function RenameItem(props) {
  const { open, setOpen, classes, folderDetails } = props;
  const [folderName, setFolderName] = useState(folderDetails?.name);
  const dispatch = useDispatch();
  const folderUpdate = useSelector((state) => state.Docs.folderUpdate);

  useEffect(() => {
    if (open) {
      setFolderName(folderDetails?.name);
    }
  }, [folderDetails, open]);

  const handleRenameFolder = () => {
    if (folderName.trim() === "") {
      toast.error("Please enter a folder name", { theme: "colored" });
      return;
    }
    dispatch(
      updateFolder({
        id: folderDetails?.id,
        schema: { name: folderName },
        handleSuccess: () => {
          handleClose();
          toast.success("Folder renamed successfully", { theme: "colored" });
        },
        handleError: (error) => {
          toast.error(JSON.stringify(error), { theme: "colored" });
        },
      })
    );
  };

  const handleClose = () => {
    setOpen(false);
    setFolderName("");
  };
  return (
    <Fragment>
      <Dialog disablePortal open={open} fullWidth={true} maxWidth={"sm"}>
        <DialogTitle className={classes.modalHeader}>
          <Typography className={classes.modalTitle}>
            {" "}
            Rename Item: {folderDetails?.name}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <InputLabel className={classes.inputLabel}>
            Please Enter a new name for the item:
          </InputLabel>
          <Grid container spacing={3}>
            <Grid item xs={1}>
              <FolderRoundedIcon
                sx={{ mt: "5px", color: "#757575", fontSize: "28px" }}
              />
            </Grid>
            <Grid item xs={11}>
              <TextField
                fullWidth
                size="small"
                className={classes.EditMlsField}
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding: "10px  20px 20px 0px" }}>
          <Button onClick={handleClose} className={classes.cancelButton}>
            Cancel
          </Button>
          <LoadingButton
            disabled={!Boolean(folderName)}
            className={classes.doneButton}
            onClick={() => handleRenameFolder()}
            loading={folderUpdate.isLoading}
            loadingPosition="end"
          >
            Done
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
export default withStyles(styleSheet, { name: "RenameItemStyle" })(RenameItem);
